import React, { useState } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { Col, Form, Row } from "react-bootstrap";
import TitlePage from "../../../../components/TitlePage";
import ResponsiveDataTable from "../../../../components/DataTable";
import SubmitForm from "../../../../components/SubmitForm";

const ImportarCliente = () => {
  const [clientes, setClientes] = useState([]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
  
        // Usa a primeira linha como referência para os campos
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  
        const headers = jsonData[0];  // Primeira linha com os títulos
        const rows = jsonData.slice(1);  // Restante das linhas
  
        const data = rows.map((row) =>
            Object.fromEntries(headers.map((header, index) => [header, row[index] || '']))
        );

        const clientesProcessados = processarClientes(data);
        setClientes(clientesProcessados);
      };
      reader.readAsBinaryString(file);
    }
  };
  

  const processarClientes = (data) => {
    let clientesProcessados = [];

    data.forEach((row) => {
      const contatos = row["NomeContato"].split(";");
      const telefones = row["Telefone"].split(";");

      contatos.forEach((contato, index) => {
        clientesProcessados.push({
          NomeUnidade: row["NomeUnidade"],
          Nome: row["Nome"] || row["NomeUnidade"],
          CNPJ: row["CNPJ"],
          Segmento: row["Segmento"],
          Relacao: row["Relacao"],
          AvaliacaoFinanceira: row["AvaliacaoFinanceira"],
          Marcadores: row["Marcadores"],
          Endereco: row["Endereço"],
          Numero: row["Numero"],
          Complemento: row["Complemento"],
          Bairro: row["Bairro"],
          CEP: row["CEP"],
          Municipio: row["Municipio"],
          UF: row["UF"],
          Pais: row["Pais"],
          NomeContato: contato.trim(),
          Telefone: telefones[index]?.trim() || "",
          Email: row["Email"],
          Site: row["Site"],
          Observacao: row["Observacao"],
        });
      });
    });

    return clientesProcessados;
  };

  const handleSubmit = () => {
    // Aqui você pode fazer o envio dos dados para sua API
    console.log(clientes);
    // Exemplo: axios.post('/api/clientes', { clientes });
  };

  return (
    <>
        <Row>
            <Col md="12" xs="12">
                <TitlePage text="Importação de Clientes" exibirIncluir={false}/>
            </Col>
        </Row>
        <Row>
            <Col md={6}>
                <Form.Group>
                    <Form.Label>Selecione a Planilha</Form.Label>
                    <Form.Control
                        type="file" 
                        accept=".csv, .xlsx"
                        onChange={handleFileUpload}
                        />
                </Form.Group>
            </Col>
        </Row>
        
        { clientes && clientes.length > 0 && 
            <SubmitForm 
                onEnviar={handleSubmit}
            />
        }

        {  clientes && clientes.length > 0 && (
            <ResponsiveDataTable
                columns={[
                    {
                        Header: 'Nome Grupo',
                        accessor: 'Nome'
                    },
                    {
                        Header: 'Nome Unidade',
                        accessor: 'NomeUnidade'
                    },
                    {
                        Header: 'Nome Contato',
                        accessor: 'NomeContato'
                    },
                    {
                        Header: 'Telefone',
                        accessor: 'Telefone'
                    },
                    {
                        Header: 'CNPJ',
                        accessor: 'CNPJ'
                    }
                ]}
                data={clientes}
                habilitaBuscar={false}
            />
        )}

    </>
    );
};

export default ImportarCliente;
